/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import './SortableHeaderStyles.scss';
const baseClass = 'qmb-ui-sortable-header';
/**
 * SortableHeader Component
 * Clickable column header that toggles sort direction.
 * Cycle: null → asc → desc → null
 *
 * @version 1.0.0
 * @since 2026-02-18
 */
export function SortableHeader({ label, dataKey, sortDirection, active, onSort, className }) {
    const handleClick = () => {
        if (!active || sortDirection === null) {
            onSort(dataKey, 'asc');
        }
        else if (sortDirection === 'asc') {
            onSort(dataKey, 'desc');
        }
        else {
            onSort(dataKey, null);
        }
    };
    return (React.createElement("button", { type: "button", className: classNames(baseClass, className, { [`${baseClass}--active`]: active }), onClick: handleClick, "aria-label": `Sort by ${typeof label === 'string' ? label : dataKey}` },
        React.createElement("span", { className: `${baseClass}__label` }, label),
        React.createElement("span", { className: `${baseClass}__icon` },
            active && sortDirection === 'asc' && React.createElement("i", { className: "fa-light fa-arrow-up-short-wide" }),
            active && sortDirection === 'desc' && React.createElement("i", { className: "fa-light fa-arrow-down-wide-short" }),
            (!active || sortDirection === null) && React.createElement("i", { className: "fa-light fa-arrows-up-down" }))));
}
